import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { History } from "lucide-react";
import { formatToIST } from "@/utils/dateUtils";

/**
 * Pre-LRN order edit history — renders the order's `edit_history` (field-level
 * diffs recorded by PUT /orders/{id}). Shared by the admin + seller order detail
 * pages. Renders nothing when there are no edits.
 */
export default function OrderEditHistory({ history }) {
  if (!Array.isArray(history) || history.length === 0) return null;
  const entries = [...history].sort((a, b) => new Date(b.edited_at || 0) - new Date(a.edited_at || 0));

  return (
    <Card className="border-0 shadow-lg" data-testid="order-edit-history">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <History className="w-5 h-5" style={{ color: "#00A699" }} />
          Edit History
        </CardTitle>
      </CardHeader>
      <CardContent>
        <ol className="relative border-l-2 border-slate-100 pl-5 space-y-5">
          {entries.map((e, i) => (
            <li key={e.id || i} className="relative">
              <span className="absolute -left-[27px] top-1.5 w-3 h-3 rounded-full bg-brand ring-4 ring-white" />
              <div className="flex flex-wrap items-baseline justify-between gap-2">
                <p className="text-sm font-semibold text-slate-800">
                  {e.edited_by?.user_name || "Unknown"}
                  {e.edited_by?.role ? <span className="text-xs font-normal text-slate-400"> · {e.edited_by.role}</span> : null}
                </p>
                <p className="text-xs text-slate-400">{e.edited_at ? formatToIST(e.edited_at) : ""}</p>
              </div>
              <ul className="mt-1.5 space-y-1">
                {(e.changes || []).map((c, j) => (
                  <li key={j} className="text-sm">
                    <span className="font-medium text-slate-700">{c.label}: </span>
                    <span className="text-slate-400 line-through break-words">{c.from === null || c.from === undefined || c.from === "" ? "—" : String(c.from)}</span>
                    <span className="text-slate-400"> → </span>
                    <span className="text-slate-900 break-words">{c.to === null || c.to === undefined || c.to === "" ? "—" : String(c.to)}</span>
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ol>
      </CardContent>
    </Card>
  );
}
